(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-password"]) return;
  try {
    
  const initializePasswordSection = (root = document) => {
    root.querySelectorAll('[data-password-access]').forEach((access) => {
      if (access.querySelector('.main-password__error')) access.open = true;
    });
    root.querySelectorAll('[data-password-countdown]').forEach((countdown) => {
      if (countdown.dataset.countdownInitialized === 'true') return;
    const value = (countdown.dataset.deadline || '').trim();
    const localDate = value.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
    const deadline = localDate ? new Date(Number(localDate[3]), Number(localDate[2]) - 1, Number(localDate[1]), Number(localDate[4] || 0), Number(localDate[5] || 0), Number(localDate[6] || 0)).getTime() : Date.parse(value);
    if (!Number.isFinite(deadline)) return;
    countdown.dataset.countdownInitialized = 'true';
    const units = { days: countdown.querySelector('[data-countdown-days]'), hours: countdown.querySelector('[data-countdown-hours]'), minutes: countdown.querySelector('[data-countdown-minutes]'), seconds: countdown.querySelector('[data-countdown-seconds]') };
    const countdownUnits = countdown.querySelector('.main-password__countdown-units');
    const finished = countdown.querySelector('[data-countdown-finished]');
    const update = () => {
      const remaining = Math.max(0, deadline - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      units.days.textContent = String(days).padStart(2, '0');
      units.hours.textContent = String(hours).padStart(2, '0');
      units.minutes.textContent = String(minutes).padStart(2, '0');
      units.seconds.textContent = String(seconds).padStart(2, '0');
      countdown.hidden = false;
      if (remaining === 0) { countdownUnits.hidden = true; finished.hidden = false; return false; }
      return true;
    };
    if (update()) { const timer = window.setInterval(() => { if (!update()) window.clearInterval(timer); }, 1000); }
    });
  };

  initializePasswordSection();
  document.addEventListener('shopify:section:load', (event) => initializePasswordSection(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-main-product]').forEach((productSection) => {
    const form = productSection.querySelector('.main-product__form');
    const variantInput = productSection.querySelector('[data-product-variant-input]');
    const prices = Array.from(productSection.querySelectorAll('[data-product-price]'));
    const addButton = productSection.querySelector('[data-product-add]');
    const status = productSection.querySelector('[data-product-status]');
    const mediaScroller = productSection.querySelector('.main-product__media');
    const mediaItems = Array.from(productSection.querySelectorAll('.main-product__media-item'));
    const mediaThumbnails = Array.from(productSection.querySelectorAll('[data-product-media-thumbnail]'));
    const mediaCounterCurrent = productSection.querySelector('[data-product-media-counter-current]');
    const previousMedia = productSection.querySelector('[data-product-media-previous]');
    const nextMedia = productSection.querySelector('[data-product-media-next]');
    const sizeGuideDialog = productSection.querySelector('[data-size-guide-dialog]');
    const sizeGuideOpen = productSection.querySelector('[data-size-guide-open]');
    const sizeGuideClose = productSection.querySelector('[data-size-guide-close]');
    const root = window.Shopify?.routes?.root || '/';
    const variantsDataElement = productSection.querySelector('[data-product-variants]');
    const optionGroups = Array.from(productSection.querySelectorAll('[data-product-option-group]'));
    let variants = [];

    try {
      variants = variantsDataElement ? JSON.parse(variantsDataElement.textContent) : [];
    } catch (error) {
      console.warn('Unable to read product variants.', error);
    }

    const selectedOptions = optionGroups.map((group) => {
      const selected = group.querySelector('[data-product-option-value].is-selected');
      const select = group.querySelector('[data-product-option-select]');
      return selected?.dataset.productOptionValue || select?.value || group.querySelector('[data-product-option-value]')?.dataset.productOptionValue || '';
    });

    const findSelectedVariant = () => variants.find((variant) => (
      variant.options.every((value, index) => value === selectedOptions[index])
    ));

    const updateVariantState = () => {
      const variant = findSelectedVariant();
      optionGroups.forEach((group, optionIndex) => {
        const select = group.querySelector('[data-product-option-select]');
        if (select) {
          select.value = selectedOptions[optionIndex];
          Array.from(select.options).forEach((option) => {
            const hasAvailableCombination = variants.some((candidate) => (
              candidate.available && candidate.options[optionIndex] === option.value
            ));
            option.disabled = !hasAvailableCombination && option.value !== selectedOptions[optionIndex];
          });
          return;
        }
        group.querySelectorAll('[data-product-option-value]').forEach((option) => {
          const selected = option.dataset.productOptionValue === selectedOptions[optionIndex];
          const hasAvailableCombination = variants.some((candidate) => (
            candidate.available && candidate.options[optionIndex] === option.dataset.productOptionValue
          ));
          option.classList.toggle('is-selected', selected);
          option.setAttribute('aria-pressed', String(selected));
          option.disabled = !hasAvailableCombination;
        });
      });

      if (!variant) {
        addButton.disabled = true;
        return;
      }

      variantInput.value = variant.id;
      addButton.disabled = !variant.available;
      prices.forEach((price) => {
        const currentPrice = price.querySelector('[data-product-current-price]');
        const comparePrice = price.querySelector('[data-product-compare-price]');
        if (currentPrice) currentPrice.textContent = variant.price;
        if (comparePrice) {
          comparePrice.hidden = !variant.onSale;
          comparePrice.textContent = variant.onSale ? variant.comparePrice : '';
        }
        price.classList.toggle('main-product__price--sale', variant.onSale);
      });
    };

    if (sizeGuideDialog && sizeGuideOpen && sizeGuideClose) {
      sizeGuideOpen.addEventListener('click', () => sizeGuideDialog.showModal());
      sizeGuideClose.addEventListener('click', () => sizeGuideDialog.close());
      sizeGuideDialog.addEventListener('click', (event) => {
        if (event.target === sizeGuideDialog) sizeGuideDialog.close();
      });
    }

    if (mediaScroller) {
      const isHorizontalMedia = () => productSection.classList.contains('main-product--media-horizontal') || window.matchMedia('(max-width: 749px)').matches;
      let activeMediaIndex = 0;

      const updateMediaState = () => {
        activeMediaIndex = 0;
        let closestOffset = Infinity;
        mediaItems.forEach((item, index) => {
          const offset = isHorizontalMedia()
            ? Math.abs(item.offsetLeft - mediaScroller.scrollLeft)
            : Math.abs((item.getBoundingClientRect().top + item.getBoundingClientRect().height / 2) - window.innerHeight / 2);
          if (offset < closestOffset) {
            closestOffset = offset;
            activeMediaIndex = index;
          }
        });
        mediaThumbnails.forEach((thumbnail, index) => thumbnail.setAttribute('aria-pressed', String(index === activeMediaIndex)));
        if (mediaCounterCurrent) mediaCounterCurrent.textContent = String(activeMediaIndex + 1).padStart(2, '0');
        if (previousMedia && nextMedia) {
          /* The side gallery is circular: its controls stay available at both
             ends and simply wrap to the opposing image. */
          previousMedia.disabled = false;
          nextMedia.disabled = false;
        }
      };
      mediaThumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          if (isHorizontalMedia()) {
            mediaScroller.scrollTo({ left: mediaItems[index]?.offsetLeft || 0, behavior: 'smooth' });
          } else {
            mediaItems[index]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
      if (previousMedia && nextMedia) {
        const scrollToMedia = (index) => {
          mediaScroller.scrollTo({ left: mediaItems[index]?.offsetLeft || 0, behavior: 'smooth' });
        };
        previousMedia.addEventListener('click', () => {
          scrollToMedia(activeMediaIndex === 0 ? mediaItems.length - 1 : activeMediaIndex - 1);
        });
        nextMedia.addEventListener('click', () => {
          scrollToMedia(activeMediaIndex === mediaItems.length - 1 ? 0 : activeMediaIndex + 1);
        });
      }
      mediaScroller.addEventListener('scroll', updateMediaState, { passive: true });
      window.addEventListener('scroll', updateMediaState, { passive: true });
      window.addEventListener('resize', updateMediaState);
      updateMediaState();
    }

    if (mediaScroller) {
      let mouseDragStartX = 0;
      let mouseDragStartScroll = 0;
      let isMouseDragging = false;

      mediaScroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        isMouseDragging = true;
        mouseDragStartX = event.clientX;
        mouseDragStartScroll = mediaScroller.scrollLeft;
        mediaScroller.setPointerCapture(event.pointerId);
        mediaScroller.classList.add('is-dragging');
      });

      mediaScroller.addEventListener('pointermove', (event) => {
        if (!isMouseDragging) return;
        event.preventDefault();
        mediaScroller.scrollLeft = mouseDragStartScroll - (event.clientX - mouseDragStartX);
      });

      const endMouseDrag = () => {
        isMouseDragging = false;
        mediaScroller.classList.remove('is-dragging');
      };

      mediaScroller.addEventListener('pointerup', endMouseDrag);
      mediaScroller.addEventListener('pointercancel', endMouseDrag);
    }

    if (optionGroups.length && variants.length) {
      optionGroups.forEach((group, optionIndex) => {
        const select = group.querySelector('[data-product-option-select]');
        select?.addEventListener('change', () => {
          selectedOptions[optionIndex] = select.value;
          updateVariantState();
        });
        group.querySelectorAll('[data-product-option-value]').forEach((option) => {
          option.addEventListener('click', () => {
            if (option.disabled) return;
            selectedOptions[optionIndex] = option.dataset.productOptionValue;
            updateVariantState();
          });
        });
      });
      updateVariantState();
    }

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (addButton.disabled) return;
      const defaultLabel = addButton.dataset.addLabel;
      addButton.disabled = true;
      status.textContent = '';
      try {
        const response = await fetch(`${root}cart/add.js`, {
          body: JSON.stringify({ id: Number(variantInput.value), quantity: 1 }),
          headers: { 'Content-Type': 'application/json' },
          method: 'POST'
        });
        if (!response.ok) throw new Error('Unable to add item');
        addButton.querySelector('span').textContent = addButton.dataset.addedLabel;
        window.dispatchEvent(new Event('minimal:cart-updated'));
        window.setTimeout(() => {
          addButton.querySelector('span').textContent = defaultLabel;
          addButton.disabled = false;
        }, 600);
      } catch (error) {
        status.textContent = 'Unable to add this item. Please try again.';
        addButton.disabled = false;
      }
    });
  });

  document.querySelectorAll('[data-animated-details]').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;

    let closeTimer;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      window.clearTimeout(closeTimer);

      if (!details.open) {
        details.open = true;
        if (reducedMotion) {
          details.classList.add('is-expanded');
        } else {
          window.requestAnimationFrame(() => details.classList.add('is-expanded'));
        }
        return;
      }

      if (!details.classList.contains('is-expanded')) {
        details.classList.add('is-expanded');
        return;
      }

      details.classList.remove('is-expanded');
      if (reducedMotion) {
        details.open = false;
        return;
      }

      closeTimer = window.setTimeout(() => {
        details.open = false;
      }, 420);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-cart-drawer"]) return;
  try {
    
  document.querySelectorAll('[data-cart-drawer]').forEach((drawer) => {
    const content = drawer.querySelector('[data-cart-content]');
    const recommendations = JSON.parse(drawer.querySelector('[data-cart-recommendations]')?.textContent || '[]');
    const root = window.Shopify?.routes?.root || '/';
    const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      currency: currency || 'USD',
      currencyDisplay: 'symbol',
      style: 'currency'
    }).format(amount / 100);
    const decodeHtml = (value) => {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = String(value || '');
      return textarea.value;
    };
    const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
    })[character]);
    const shippingGoal = Math.max(0, Number(drawer.dataset.freeShippingGoal || 0)) * 100;
    let latestCart;
    let lastTrigger;
    let recommendationsCollapsed = false;

    const recommendationMarkup = (cart) => {
      const cartProductIds = new Set(cart.items.map((item) => item.product_id));
      const available = recommendations.filter((product) => product.available && !cartProductIds.has(product.id)).slice(0, 5);
      if (!available.length) return '';

      return `
        <section class="minimal-cart-drawer__recommendations${recommendationsCollapsed ? ' is-collapsed' : ''}">
          <button class="minimal-cart-drawer__recommendations-title" type="button" data-recommendations-toggle aria-expanded="${String(!recommendationsCollapsed)}">${escapeHtml(drawer.dataset.recommendationsLabel)}</button>
          <div class="minimal-cart-drawer__recommendations-grid">
            ${available.map((product) => `
              <article>
                <a class="minimal-cart-drawer__recommendation-image" href="${escapeHtml(product.url)}">
                  ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
                </a>
                <a class="minimal-cart-drawer__recommendation-title" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
                <span class="minimal-cart-drawer__recommendation-price">${money(product.price, cart.currency)}</span>
                ${product.hasSingleVariant ? `<button class="minimal-cart-drawer__recommendation-action" type="button" data-recommendation-add="${product.variantId}">${escapeHtml(drawer.dataset.addLabel)}</button>` : `<a class="minimal-cart-drawer__recommendation-action" href="${escapeHtml(product.url)}">${escapeHtml(drawer.dataset.viewLabel)}</a>`}
              </article>
            `).join('')}
          </div>
        </section>
      `;
    };

    const itemMarkup = (item, cart) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="minimal-cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>` : '';
      const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
      const removeLabel = drawer.dataset.removeLabel.replace('__product__', item.product_title);
      return `
        <article class="minimal-cart-drawer__item">
          <a class="minimal-cart-drawer__image" href="${escapeHtml(item.url)}">${image}</a>
          <div>
            <a class="minimal-cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${variant}
            <p class="minimal-cart-drawer__item-price">${money(item.final_line_price, cart.currency)}</p>
          </div>
          <div class="minimal-cart-drawer__quantity">
            <button class="minimal-cart-drawer__quantity-button" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="${escapeHtml(drawer.dataset.decreaseLabel)}">−</button>
            <span>${item.quantity}</span>
            <button class="minimal-cart-drawer__quantity-button" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="${escapeHtml(drawer.dataset.increaseLabel)}">+</button>
            <button class="minimal-cart-drawer__remove" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="0" aria-label="${escapeHtml(removeLabel)}">×</button>
          </div>
        </article>
      `;
    };

    const render = (cart) => {
      latestCart = cart;
      if (!cart.item_count) {
        content.innerHTML = `<p class="minimal-cart-drawer__empty">${escapeHtml(drawer.dataset.emptyLabel)}</p><a class="minimal-cart-drawer__continue" href="${escapeHtml(root)}">${escapeHtml(drawer.dataset.continueLabel)}</a>`;
        return;
      }

      const remaining = Math.max(0, shippingGoal - cart.total_price);
      const progress = shippingGoal ? Math.min(100, (cart.total_price / shippingGoal) * 100) : 0;
      const shipping = shippingGoal ? (remaining ? decodeHtml(drawer.dataset.awayLabel).replace('__amount__', money(remaining, cart.currency)) : decodeHtml(drawer.dataset.freeShippingLabel)) : '';
      content.innerHTML = `
        ${shippingGoal ? `<p class="minimal-cart-drawer__shipping">${escapeHtml(shipping)}</p><div class="minimal-cart-drawer__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}"><span class="minimal-cart-drawer__progress-fill" style="width:${progress}%"></span></div>` : ''}
        <div class="minimal-cart-drawer__items">${cart.items.map((item) => itemMarkup(item, cart)).join('')}</div>
        ${recommendationMarkup(cart)}
        <div class="minimal-cart-drawer__footer">
          <span class="minimal-cart-drawer__total-label">${escapeHtml(drawer.dataset.totalLabel)}</span>
          <span class="minimal-cart-drawer__total-price">${money(cart.total_price, cart.currency)}</span>
          <a class="minimal-cart-drawer__checkout" href="${root}checkout">${escapeHtml(drawer.dataset.checkoutLabel)}</a>
        </div>
      `;
    };

    const getCart = async () => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load cart');
      const cart = await response.json();
      render(cart);
      return cart;
    };

    let closeTimer;

    const close = () => {
      window.clearTimeout(closeTimer);
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      lastTrigger?.focus();
      closeTimer = window.setTimeout(() => { drawer.hidden = true; }, 540);
    };

    const open = async (trigger) => {
      window.clearTimeout(closeTimer);
      lastTrigger = trigger || document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      void drawer.offsetWidth;
      window.requestAnimationFrame(() => drawer.classList.add('is-open'));
      drawer.querySelector('[data-cart-close]')?.focus();
      try { await getCart(); } catch (error) { content.innerHTML = `<p class="minimal-cart-drawer__empty">${escapeHtml(drawer.dataset.emptyLabel)}</p>`; }
    };

    drawer.querySelectorAll('[data-cart-close]').forEach((control) => control.addEventListener('click', close));
    document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => trigger.addEventListener('click', (event) => { event.preventDefault(); open(trigger); }));
    window.addEventListener('minimal:cart-open', () => open());
    window.addEventListener('minimal:cart-updated', () => { if (!drawer.hidden) getCart(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !drawer.hidden) close(); });

    content.addEventListener('click', async (event) => {
      const recommendationsToggle = event.target.closest('[data-recommendations-toggle]');
      if (recommendationsToggle) {
        const section = recommendationsToggle.closest('.minimal-cart-drawer__recommendations');
        recommendationsCollapsed = section.classList.toggle('is-collapsed');
        recommendationsToggle.setAttribute('aria-expanded', String(!recommendationsCollapsed));
        return;
      }

      const change = event.target.closest('[data-cart-change]');
      const add = event.target.closest('[data-recommendation-add]');
      if (!change && !add) return;
      event.preventDefault();
      try {
        if (change) {
          await fetch(`${root}cart/change.js`, {
            body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity) }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });
        }
        if (add) {
          await fetch(`${root}cart/add.js`, {
            body: JSON.stringify({ id: Number(add.dataset.recommendationAdd), quantity: 1 }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });
        }
        await getCart();
        window.dispatchEvent(new Event('minimal:cart-updated'));
      } catch (error) {
        if (latestCart) render(latestCart);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-cookie-banner"]) return;
  try {
    
  document.querySelectorAll('[data-cookie-banner]').forEach((banner) => {
    const manageButton = banner.querySelector('[data-cookie-manage]');
    const acceptButton = banner.querySelector('[data-cookie-accept]');
    const declineButton = banner.querySelector('[data-cookie-decline]');
    const saveButton = banner.querySelector('[data-cookie-save]');
    const preferences = banner.querySelector('[data-cookie-preferences]');
    const preferenceInput = banner.querySelector('[data-cookie-preferences-input]');
    const analyticsInput = banner.querySelector('[data-cookie-analytics-input]');
    const marketingInput = banner.querySelector('[data-cookie-marketing-input]');

    const announceState = () => {
      document.dispatchEvent(new CustomEvent('minimal:cookie-banner-state', {
        detail: { visible: !banner.hidden }
      }));
    };
    const hideBanner = () => {
      banner.hidden = true;
      announceState();
    };
    const hasAnswer = (value) => value === 'yes' || value === 'no';

    const captureConsent = (consent) => {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy?.setTrackingConsent) return;
      privacy.setTrackingConsent(consent, hideBanner);
    };

    const showWhenNeeded = () => {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy) return;

      const visitorConsent = privacy.currentVisitorConsent?.() || {};
      const hasRecordedChoice = [visitorConsent.preferences, visitorConsent.analytics, visitorConsent.marketing].some(hasAnswer);
      const requiredByRegion = privacy.shouldShowBanner?.() === true;

      banner.hidden = !(requiredByRegion || !hasRecordedChoice);
      announceState();
    };

    const initialisePrivacyApi = () => {
      if (window.Shopify?.customerPrivacy) {
        showWhenNeeded();
        return;
      }

      if (!window.Shopify?.loadFeatures) {
        announceState();
        return;
      }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) {
          showWhenNeeded();
        } else {
          announceState();
        }
      });
    };

    manageButton?.addEventListener('click', () => {
      const current = window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || {};
      preferenceInput.checked = current.preferences === 'yes';
      analyticsInput.checked = current.analytics === 'yes';
      marketingInput.checked = current.marketing === 'yes';
      preferences.hidden = false;
      manageButton.hidden = true;
    });

    acceptButton?.addEventListener('click', () => captureConsent({ preferences: true, analytics: true, marketing: true }));
    declineButton?.addEventListener('click', () => captureConsent({ preferences: false, analytics: false, marketing: false }));
    saveButton?.addEventListener('click', () => captureConsent({
      preferences: preferenceInput.checked,
      analytics: analyticsInput.checked,
      marketing: marketingInput.checked
    }));

    initialisePrivacyApi();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-email-popup"]) return;
  try {
    
  document.querySelectorAll('[data-email-popup]').forEach((popup) => {
    const closeControls = popup.querySelectorAll('[data-email-popup-close]');
    /* Keep dismissal separate for phone and desktop. This also avoids an old
       desktop dismissal suppressing the first mobile test in Theme Editor. */
    const storageKey = window.matchMedia('(max-width: 749px)').matches
      ? 'minimal-email-popup-dismissed-mobile-v3'
      : 'minimal-email-popup-dismissed-desktop-v3';
    const delay = Math.max(0, Number(popup.dataset.delay || 0)) * 1000;
    let showTimer;
    let closeTimer;
    let cookieBannerReady = false;
    let cookieBannerVisible = false;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const hide = () => {
      popup.classList.remove('is-open', 'is-closing');
      popup.setAttribute('hidden', '');
      popup.setAttribute('aria-hidden', 'true');
      /* Explicitly setting display prevents an editor-preview stylesheet from
         overriding the browser's default [hidden] rule. */
      popup.style.display = 'none';
    };

    const wasDismissed = () => {
      try {
        return window.localStorage.getItem(storageKey) === 'true';
      } catch (error) {
        return false;
      }
    };

    const dismiss = () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(closeTimer);
      if (popup.hidden || popup.classList.contains('is-closing')) return;
      popup.setAttribute('aria-hidden', 'true');
      popup.classList.remove('is-open');
      popup.classList.add('is-closing');

      if (reducedMotion) {
        hide();
      } else {
        closeTimer = window.setTimeout(hide, 380);
      }
      try {
        window.localStorage.setItem(storageKey, 'true');
      } catch (error) {
        // The popup remains closable when storage is unavailable.
      }
    };

    const show = () => {
      window.clearTimeout(closeTimer);
      popup.classList.remove('is-closing', 'is-open');
      popup.removeAttribute('hidden');
      popup.removeAttribute('aria-hidden');
      popup.style.removeProperty('display');
      window.requestAnimationFrame(() => {
        popup.classList.add('is-open');
        popup.querySelector('input[type="email"]')?.focus();
      });
    };

    const scheduleShow = () => {
      if (wasDismissed() || cookieBannerVisible || showTimer) return;
      showTimer = window.setTimeout(show, delay);
    };

    const updateCookieBannerState = (event) => {
      cookieBannerReady = true;
      cookieBannerVisible = event.detail?.visible === true;
      if (!cookieBannerVisible) scheduleShow();
    };

    document.addEventListener('minimal:cookie-banner-state', updateCookieBannerState);

    closeControls.forEach((control) => control.addEventListener('click', dismiss));

    popup.addEventListener('click', (event) => {
      if (!event.target.closest('[data-email-popup-close]')) return;
      event.preventDefault();
      dismiss();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) dismiss();
    });

    if (popup.querySelector('[role="status"]')) {
      if (cookieBannerReady && !cookieBannerVisible) show();
      return;
    }

    window.addEventListener('DOMContentLoaded', () => {
      if (!document.querySelector('[data-cookie-banner]')) scheduleShow();
      if (cookieBannerReady && !cookieBannerVisible) scheduleShow();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-header"]) return;
  try {
    
  /* The theme editor preserves native checkbox state while it applies a
     setting change. A mobile menu that happened to be open must not survive
     a logo-position change and leave a detached second navigation row. */
  const closeMinimalHeaderCollections = (scope = document) => {
    scope.querySelectorAll('.minimal-header__collections-state').forEach((control) => {
      control.checked = false;
    });
  };

  document.addEventListener('shopify:section:load', (event) => {
    closeMinimalHeaderCollections(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    closeMinimalHeaderCollections(event.target);
  });

  document.querySelectorAll('.minimal-header').forEach((header) => {
    let isScheduled = false;
    const catalogScroller = document.querySelector('#MainContent');

    const updateGlassState = () => {
      header.classList.toggle('is-scrolled', Math.max(window.scrollY, catalogScroller?.scrollTop || 0) > 12);

      isScheduled = false;
    };

    updateGlassState();

    window.addEventListener('scroll', () => {
      if (isScheduled) return;

      isScheduled = true;
      window.requestAnimationFrame(updateGlassState);
    }, { passive: true });

    catalogScroller?.addEventListener('scroll', () => {
      if (isScheduled) return;

      isScheduled = true;
      window.requestAnimationFrame(updateGlassState);
    }, { passive: true });

    window.addEventListener('minimal-layout-state', (event) => {
      header.classList.toggle('is-stage-active', Boolean(document.querySelector('.product-carousel')));
    });
  });

  document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
    const root = document.documentElement;
    const storageKey = 'minimal-collections-theme-override-v2';
    const themeMode = button.dataset.themeMode || 'auto';
    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)');
    let savedTheme = null;

    try {
      savedTheme = window.localStorage.getItem(storageKey);
    } catch (error) {
      savedTheme = null;
    }

    const setTheme = (isDark) => {
      root.classList.toggle('theme-dark', isDark);
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', isDark ? button.dataset.lightLabel : button.dataset.darkLabel);
    };

    const resolveTheme = () => {
      if (savedTheme === 'dark') return true;
      if (savedTheme === 'light') return false;
      if (themeMode === 'dark') return true;
      if (themeMode === 'light') return false;
      return systemTheme.matches;
    };

    setTheme(resolveTheme());

    systemTheme.addEventListener('change', () => {
      if (savedTheme == null && themeMode === 'auto') setTheme(systemTheme.matches);
    });

    button.addEventListener('click', () => {
      const isDark = !root.classList.contains('theme-dark');
      setTheme(isDark);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches === false) {
        document.querySelectorAll('.minimal-theme-pulse').forEach((pulse) => pulse.remove());

        const pulse = document.createElement('div');
        pulse.className = 'minimal-theme-pulse';
        pulse.addEventListener('animationend', () => pulse.remove(), { once: true });
        document.body.append(pulse);

        button.animate(
          [
            { transform: 'rotate(0deg) scale(1)' },
            { transform: 'rotate(-7deg) scale(.95)' },
            { transform: 'rotate(0deg) scale(1)' }
          ],
          {
            duration: 300,
            easing: 'cubic-bezier(.16, 1, .3, 1)'
          }
        );
      }

      try {
        window.localStorage.setItem(storageKey, isDark ? 'dark' : 'light');
        savedTheme = isDark ? 'dark' : 'light';
      } catch (error) {
        return;
      }
    });
  });

  const updateCartCount = async () => {
    const triggers = Array.from(document.querySelectorAll('[data-cart-trigger]'));
    if (!triggers.length) return;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();

      triggers.forEach((trigger) => {
        const count = trigger.querySelector('[data-cart-count]');
        if (count) {
          count.textContent = cart.item_count;
        }
        trigger.setAttribute('aria-label', cart.item_count ? `${trigger.dataset.cartLabel}: ${cart.item_count}` : trigger.dataset.cartLabel);
        trigger.classList.toggle('is-cart-active', cart.item_count > 0);
      });
    } catch (error) {
      return;
    }
  };

  window.addEventListener('minimal:cart-updated', updateCartCount);

  document.querySelectorAll('[data-layout-toggle]').forEach((button) => {
    const syncLayoutToggle = ({ available, single }) => {
      /* In the editor, the carousel deliberately renders as a stable static
         grid so Shopify can safely replace the section after a setting
         change. Keep the mobile switch available there: it only changes the
         local 1/2-card preview and does not ask Shopify to re-render. */
      button.hidden = !available;
      button.dataset.layoutMode = single ? 'single' : 'grid';
      button.setAttribute('aria-label', single ? button.dataset.gridLabel : button.dataset.singleLabel);
    };

    window.addEventListener('minimal-layout-state', (event) => syncLayoutToggle(event.detail));
    if (window.minimalCatalogLayoutState) syncLayoutToggle(window.minimalCatalogLayoutState);

    /* This listener belongs to the actual header button rather than to a
       shared window handler. It therefore survives any live re-render of the
       carousel section and always dispatches to the current carousel node. */
    if (button.dataset.layoutToggleBound !== 'true' && !button.hasAttribute('onclick')) {
      button.dataset.layoutToggleBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const carousel = document.querySelector('.product-carousel');
        if (!carousel) return;

        /* Shopify can replace the carousel markup after any editor setting
           update without replaying that section's JavaScript. A static grid
           still only needs its CSS variables changed, so make the mobile
           1↔2 preview toggle work directly from the persistent header. */
        if (window.innerWidth < 750 && carousel.classList.contains('product-carousel--static-grid')) {
          const currentColumns = Number(carousel.style.getPropertyValue('--product-carousel-mobile-columns')) || 1;
          const nextColumns = currentColumns === 1 ? 2 : 1;
          carousel.style.setProperty('--product-carousel-mobile-columns', String(nextColumns));
          carousel.style.setProperty('--product-carousel-mobile-media-height', nextColumns === 2 ? '42vw' : '76vw');
          button.dataset.layoutMode = nextColumns === 1 ? 'single' : 'grid';
          button.setAttribute('aria-label', nextColumns === 1 ? button.dataset.gridLabel : button.dataset.singleLabel);
          window.minimalCatalogLayoutState = { available: true, single: nextColumns === 1 };
          return;
        }

        if (carousel.classList.contains('product-carousel--static-grid') && window.Shopify?.designMode) {
          const showingSinglePreview = carousel.classList.toggle('product-carousel--editor-single-preview');
          button.dataset.layoutMode = showingSinglePreview ? 'single' : 'grid';
          button.setAttribute('aria-label', showingSinglePreview ? button.dataset.gridLabel : button.dataset.singleLabel);
          window.minimalCatalogLayoutState = { available: true, single: showingSinglePreview };
          return;
        }

        carousel.dispatchEvent(new CustomEvent('minimal-layout-toggle'));
      });
    }
  });


  document.querySelectorAll('[data-collections-toggle]').forEach((button) => {
    const navigation = button.closest('.minimal-header__collections');
    if (!navigation) return;

    button.addEventListener('click', () => {
      const isOpen = navigation.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(isOpen));
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-related-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-related-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-related-track]');
    const previous = carousel.querySelector('[data-related-previous]');
    const next = carousel.querySelector('[data-related-next]');

    if (!track || !previous || !next) return;

    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const hasOverflow = maxScroll > 2;
      previous.hidden = !hasOverflow || track.scrollLeft <= 2;
      next.hidden = !hasOverflow || track.scrollLeft >= maxScroll - 2;
    };

    const scrollProducts = (direction) => {
      track.scrollBy({ left: direction * Math.max(track.clientWidth * .9, 220), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollProducts(-1));
    next.addEventListener('click', () => scrollProducts(1));
    track.addEventListener('scroll', updateControls, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateControls).observe(track);
    } else {
      window.addEventListener('resize', updateControls);
    }

    updateControls();
  });

  document.querySelectorAll('[data-related-media]').forEach((media) => {
    const track = media.querySelector('[data-related-media-track]');
    const slides = Array.from(media.querySelectorAll('[data-related-media-slide]'));
    const previous = media.querySelector('[data-related-media-previous]');
    const next = media.querySelector('[data-related-media-next]');
    let activeIndex = 0;

    if (!track || slides.length < 2 || !previous || !next) return;

    const showImage = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      track.style.transform = `translateX(${-activeIndex * 100}%)`;
      slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex)));
    };

    previous.addEventListener('click', () => showImage(activeIndex - 1));
    next.addEventListener('click', () => showImage(activeIndex + 1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-splash-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-splash-page]').forEach((splash) => {
    const time = splash.querySelector('[data-splash-time]');
    if (!time) return;

    const updateTime = () => {
      const now = new Date();
      const date = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(now);
      const clock = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      }).format(now);
      time.textContent = `${date}  ·  ${clock}`;
    };

    updateTime();
    window.setInterval(updateTime, 1000);
  });

  document.querySelectorAll('.minimal-splash-page--link-animation-highlight').forEach((splash) => {
    const usesTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    if (!usesTouch) return;

    const links = splash.querySelectorAll('.minimal-splash-page__links a');
    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        if (link.classList.contains('is-touch-highlighted')) return;

        event.preventDefault();
        links.forEach((otherLink) => otherLink.classList.remove('is-touch-highlighted'));
        link.classList.add('is-touch-highlighted');
      });
    });
  });

  document.querySelectorAll('[data-splash-theme-toggle]').forEach((button) => {
    const root = document.documentElement;
    const storageKey = 'minimal-collections-theme-override-v2';

    const updateButton = () => {
      const isDark = root.classList.contains('theme-dark');
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', isDark ? button.dataset.lightLabel : button.dataset.darkLabel);
    };

    updateButton();
    button.addEventListener('click', () => {
      const isDark = !root.classList.contains('theme-dark');
      root.classList.toggle('theme-dark', isDark);
      try {
        window.localStorage.setItem(storageKey, isDark ? 'dark' : 'light');
      } catch (error) {
        /* The visual toggle still works if storage is unavailable. */
      }
      updateButton();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
  const minimalCatalogLayoutStorageKey = 'minimal-collections-catalog-layout-v1';

  let isOpeningProductPage = false;

  /* Mobile Safari restores the home page from its back-forward cache instead
     of re-running this script. Reset the one-shot product-navigation guard so
     a card remains tappable after the visitor uses the browser back button. */
  window.addEventListener('pageshow', () => {
    isOpeningProductPage = false;
    document.documentElement.classList.remove('minimal-product-page-leaving');
  });

  const openProductPageFromCard = (url) => {
    if (!url) return false;
    if (isOpeningProductPage) return true;

    isOpeningProductPage = true;
    try {
      window.sessionStorage.setItem('minimal-product-page-enter', '1');
    } catch (error) {
      // Navigation still works when browser storage is unavailable.
    }

    document.documentElement.classList.add('minimal-product-page-leaving');
    window.setTimeout(() => window.location.assign(url), 220);
    return true;
  };

  document.addEventListener('click', (event) => {
    const productLink = event.target.closest?.('a[data-product-page-link]');
    if (!productLink?.href || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    openProductPageFromCard(productLink.href);
  }, true);

  const readMinimalCatalogLayout = () => {
    try {
      return JSON.parse(window.localStorage.getItem(minimalCatalogLayoutStorageKey) || '{}');
    } catch (error) {
      return {};
    }
  };
  const writeMinimalCatalogLayout = (breakpoint, layout) => {
    const savedLayout = readMinimalCatalogLayout();
    savedLayout[breakpoint] = layout;
    try {
      window.localStorage.setItem(minimalCatalogLayoutStorageKey, JSON.stringify(savedLayout));
    } catch (error) {
      return;
    }
  };
  /* Header settings can re-render independently in the theme editor. Keep the
     latest state so a newly rendered Glass or Classic header can restore its
     grid control without waiting for the carousel to initialise again. */
  const publishMinimalCatalogLayoutState = (detail) => {
    window.minimalCatalogLayoutState = detail;
    window.dispatchEvent(new CustomEvent('minimal-layout-state', { detail }));
  };

  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const track = carousel.querySelector('[data-carousel-track]');
    const pageScroller = carousel.closest('#MainContent');
    const productSlides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    const configuredColumns = Math.max(1, Number(carousel.dataset.productsPerRow) || 1);
    const configuredGridColumns = Math.min(6, Math.max(2, Number(carousel.dataset.gridColumns) || 3));
    const singleTransition = carousel.dataset.singleTransition || 'vertical';
    const isThemeEditor = Boolean(window.Shopify?.designMode);
    /* The header grid switch should feel like a catalogue on desktop, while
       mobile keeps its intentionally compact two-card layout. */
    const gridColumns = configuredColumns > 1 ? configuredColumns : Math.min(configuredGridColumns, productSlides.length);
    const hasMultipleProducts = isThemeEditor || productSlides.length > 1;
    const canUseDesktopGrid = hasMultipleProducts && gridColumns > 1;
    const canUseMobileGrid = hasMultipleProducts;
    const savedLayout = readMinimalCatalogLayout();
    let activeIndex = 0;
    let gridFocusIndex = 0;
    let isTransitioning = false;
    let isSingleLayout = configuredColumns === 1;
    let startX = 0;
    let startY = 0;
    let swipeOffset = 0;
    let mobileDragFrame = 0;
    let footerOpen = false;
    let footerUnlockAt = 0;
    let stageResumeLockedUntil = 0;
    let stageTransitionTimer;
    let wheelGestureActive = false;
    let wheelGestureDirection = 0;
    let wheelGestureReleaseTimer;
    let desktopLastStageReady = productSlides.length === 1;
    let desktopLastStageUnlockTimer;
    let mobileGridActive = false;
    let stageTouchEnabled = false;
    const stageMediaPrevious = carousel.querySelector('[data-stage-media-previous]');
    const stageMediaNext = carousel.querySelector('[data-stage-media-next]');
    const productCounterCurrent = carousel.querySelector('[data-product-counter-current]');
    const productCounterTotal = carousel.querySelector('[data-product-counter-total]');

    const isMobileGrid = () => mobileGridActive && window.innerWidth < 750;
    const usesHorizontalCarousel = () => !isMobileGrid() && isSingleLayout && singleTransition === 'horizontal' && window.innerWidth >= 750;
    const usesVerticalCarousel = () => !isMobileGrid() && !usesHorizontalCarousel() && (isSingleLayout || window.innerWidth < 750);
    const usesStageCarousel = () => usesHorizontalCarousel() || usesVerticalCarousel();
    /* The original product feed used the browser's native scroll physics.
       Keep that behaviour on mobile too: it handles quick reversals and
       momentum far more reliably than translating the track in JavaScript. */
    const usesNativeStage = () => !footerOpen && usesVerticalCarousel();
    const isLastStageProduct = () => !mobileGridActive && activeIndex === productSlides.length - 1;
    const isMobileLastProduct = () => window.innerWidth < 750 && isLastStageProduct();
    const armDesktopLastStageHandoff = () => {
      if (window.innerWidth < 750 || !isLastStageProduct()) return;

      window.clearTimeout(desktopLastStageUnlockTimer);
      desktopLastStageUnlockTimer = window.setTimeout(() => {
        if (!isLastStageProduct() || isTransitioning) return;
        desktopLastStageReady = true;
        syncLastStageProduct();
      }, 160);
    };
    const syncLastStageProduct = () => {
      const isLastProduct = isLastStageProduct();

      if (isLastProduct) {
        if (window.innerWidth >= 750 && desktopLastStageReady) {
          pageScroller?.style.setProperty('overflow-y', 'auto');
          pageScroller?.style.setProperty('scroll-behavior', 'auto');
        } else {
          pageScroller?.style.removeProperty('overflow-y');
          pageScroller?.style.removeProperty('scroll-behavior');
        }
        if (window.innerWidth < 750) viewport.style.setProperty('touch-action', 'pan-y');
        return;
      }

      desktopLastStageReady = false;
      window.clearTimeout(desktopLastStageUnlockTimer);
      pageScroller?.style.removeProperty('overflow-y');
      pageScroller?.style.removeProperty('scroll-behavior');
      viewport.style.removeProperty('touch-action');
    };

    const syncStageMediaArrows = () => {
      const media = productSlides[activeIndex]?.querySelector('[data-product-media-carousel]');
      const show = usesVerticalCarousel() && (media?.querySelectorAll('[data-media-slide]').length || 0) > 1;
      [stageMediaPrevious, stageMediaNext].forEach((control) => {
        if (control) control.hidden = !show;
      });
    };

    const syncProductCounter = () => {
      if (productCounterCurrent) productCounterCurrent.textContent = String(activeIndex + 1).padStart(2, '0');
      if (productCounterTotal) productCounterTotal.textContent = String(productSlides.length).padStart(2, '0');
    };

    const notifyLayoutState = () => {
      const isMobile = window.innerWidth < 750;
      publishMinimalCatalogLayoutState({
        available: !isThemeEditor && (isMobile ? canUseMobileGrid : canUseDesktopGrid),
        single: isMobile ? !mobileGridActive : isSingleLayout
      });
    };

    const updateTrackPosition = (offset = 0) => {
      if (usesNativeStage()) {
        track.style.transform = '';
        if (offset === 0) {
          const top = activeIndex * viewport.clientHeight;
          if (Math.abs(viewport.scrollTop - top) > 1) {
            viewport.scrollTo({
              top,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        }
        return;
      }
      if (usesHorizontalCarousel()) {
        track.style.transform = `translate3d(${-activeIndex * viewport.clientWidth + offset}px, 0, 0)`;
        return;
      }
      track.style.transform = `translate3d(0, ${-activeIndex * viewport.clientHeight + offset}px, 0)`;
    };

    const updateMobileDragPosition = () => {
      mobileDragFrame = 0;
      updateTrackPosition(swipeOffset);
    };

    const resetCatalogScroll = () => {
      if (pageScroller && pageScroller.scrollTop !== 0) {
        pageScroller.scrollTo({ top: 0, behavior: 'auto' });
      }
    };

    const setFooterOpen = (open) => {
      /* A single-product stage never hands off to the document footer. The
         product viewport retains its own scrolling; grid mode keeps normal
         page scrolling on every screen size. */
      if (open && isSingleLayout && !mobileGridActive) open = false;

      const wasOpen = footerOpen;
      footerOpen = open;
      carousel.classList.toggle('product-carousel--footer-open', open);
      if (open && pageScroller) {
        window.requestAnimationFrame(() => {
          pageScroller.scrollTo({
            top: pageScroller.scrollHeight,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        });
      } else {
        resetCatalogScroll();
        if (wasOpen) {
          stageResumeLockedUntil = Date.now() + (window.innerWidth < 750 ? 420 : 620);
        }
      }
    };

    const navigateStage = (direction) => {
      if (!usesStageCarousel()) return;

      if (!footerOpen && Date.now() < stageResumeLockedUntil) return;

      if (footerOpen) {
        if (direction < 0) setFooterOpen(false);
        return;
      }

      if (direction > 0 && activeIndex === productSlides.length - 1) {
        return;
      }

      if (direction < 0 && activeIndex === 0) return;
      showProduct(activeIndex + direction);
    };

    const warmProductImage = (index) => {
      const image = productSlides[index]?.querySelector('.product-carousel__image');
      if (!image) return;

      image.loading = 'eager';
      image.fetchPriority = 'high';
    };

    const showProduct = (index) => {
      if (!usesStageCarousel()) return;

      const nextIndex = Math.max(0, Math.min(index, productSlides.length - 1));

      if (nextIndex === activeIndex) return;

      isTransitioning = true;
      resetCatalogScroll();
      warmProductImage(nextIndex);
      activeIndex = nextIndex;
      warmProductImage(activeIndex - 1);
      warmProductImage(activeIndex + 1);
      syncLastStageProduct();
      /* Keep the last stage from opening the footer until its latest movement
         settles, while allowing a new swipe to retarget the track instantly. */
      footerUnlockAt = activeIndex === productSlides.length - 1
        ? Date.now() + (window.innerWidth < 750 ? 340 : 900)
        : 0;
      productSlides[activeIndex].classList.add('is-revealed');
      updateTrackPosition();

      productSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
      });
      syncStageMediaArrows();
      syncProductCounter();

      window.clearTimeout(stageTransitionTimer);
      stageTransitionTimer = window.setTimeout(() => {
        isTransitioning = false;
        armDesktopLastStageHandoff();
      }, window.innerWidth < 750 ? 300 : 460);
    };

    let nativeStageScrollFrame = 0;
    const syncNativeStage = () => {
      nativeStageScrollFrame = 0;
      if (!usesNativeStage() || !viewport.clientHeight) return;

      const nextIndex = Math.max(0, Math.min(
        Math.round(viewport.scrollTop / viewport.clientHeight),
        productSlides.length - 1
      ));
      if (nextIndex === activeIndex) return;

      activeIndex = nextIndex;
      productSlides[activeIndex].classList.add('is-revealed');
      productSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
      });
      syncLastStageProduct();
      syncStageMediaArrows();
      syncProductCounter();
    };

    const applyLayout = (single, savePreference = true) => {
      const wasSingleLayout = isSingleLayout;
      isSingleLayout = single;
      document.documentElement.classList.toggle('minimal-catalog-grid-initial', !single && window.innerWidth >= 750);
      carousel.classList.toggle('product-carousel--columns-1', single);
      carousel.classList.toggle(`product-carousel--columns-${gridColumns}`, !single);
      activeIndex = single ? gridFocusIndex : 0;
      isTransitioning = false;
      window.clearTimeout(stageTransitionTimer);
      footerUnlockAt = 0;
      setFooterOpen(false);
      resetCatalogScroll();
      syncLastStageProduct();
      if (single) {
        if (!wasSingleLayout) track.style.transition = 'none';
        updateTrackPosition();
        if (!wasSingleLayout) {
          track.getBoundingClientRect();
          track.style.transition = '';
        }
        productSlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
        });
      } else {
        /* A product's size picker is designed for the one-product stage. In a
           four-card catalogue it stretches the entire grid row, so close any
           open picker before returning to the compact grid. */
        productSlides.forEach((slide) => {
          /* A product that was not yet visited in the one-product stage still
             has its vertical reveal state. A grid must never make those cards
             rise in from below when it opens. */
          slide.classList.add('is-revealed');
          slide.classList.remove('is-expanded');
          slide.querySelector('[data-product-toggle]')?.setAttribute('aria-expanded', 'false');
        });
        /* Freeze the stage track while it becomes a grid. Without this, a
           product viewed lower in the stage first animates back through every
           preceding product before its grid card can be positioned. */
        if (wasSingleLayout) track.style.transition = 'none';
        track.style.transform = '';
        if (wasSingleLayout) {
          track.getBoundingClientRect();
          track.style.transition = '';
        }
        productSlides.forEach((slide) => slide.setAttribute('aria-hidden', 'false'));
      }

      notifyLayoutState();
      syncStageMediaArrows();
      syncProductCounter();
      if (savePreference) writeMinimalCatalogLayout('desktop', single ? 'single' : 'grid');
    };

    const alignGridToFocusedProduct = (index) => {
      /* The first row is already in the ideal position. For subsequent rows,
         put the selected card beneath the header before the new View
         Transition snapshot is taken. This uses its actual layout position,
         not a hard-coded product count, so any collection length works. */
      if (!pageScroller || index < gridColumns) return;

      const focusedSlide = productSlides[index];
      if (!focusedSlide) return;

      const header = document.querySelector('.minimal-header');
      const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      const targetTop = Math.max(headerBottom + 24, 160);
      const currentTop = focusedSlide.getBoundingClientRect().top;
      const nextScrollTop = Math.max(0, pageScroller.scrollTop + currentTop - targetTop);

      pageScroller.scrollTop = nextScrollTop;
    };

    const transitionFocusedProductLayout = (single, focusedSlide, focusedIndex, savePreference) => {
      gridFocusIndex = focusedIndex;
      applyLayout(single, savePreference);
      if (!single) alignGridToFocusedProduct(focusedIndex);
      carousel.animate(
        [
          { opacity: .72 },
          { opacity: 1 }
        ],
        {
          duration: 360,
          easing: 'cubic-bezier(.16, 1, .3, 1)',
          fill: 'both'
        }
      );
    };

    const setLayout = (single, savePreference = true) => {
      if (!canUseDesktopGrid || single === isSingleLayout) return;

      const canAnimateLayout = savePreference
        && window.innerWidth >= 990
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches === false;

      if (canAnimateLayout) {
        const focusedIndex = single ? gridFocusIndex : activeIndex;
        const focusedSlide = productSlides[focusedIndex];

        if (!focusedSlide) {
          applyLayout(single, savePreference);
          return;
        }

        transitionFocusedProductLayout(single, focusedSlide, focusedIndex, savePreference);
        return;
      }

      applyLayout(single, savePreference);
    };

    const setMobileGrid = (active, savePreference = true) => {
      active = active && canUseMobileGrid;
      mobileGridActive = active;
      carousel.classList.toggle('product-carousel--mobile-grid-active', active);
      carousel.style.setProperty('--product-carousel-mobile-columns', active ? '2' : '1');
      carousel.style.setProperty('--product-carousel-mobile-media-height', active ? '42vw' : '76vw');

      if (active) {
        track.style.transform = '';
        productSlides.forEach((slide) => slide.setAttribute('aria-hidden', 'false'));
      } else {
        activeIndex = 0;
        updateTrackPosition();
        productSlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
        });
      }

      notifyLayoutState();
      syncStageMediaArrows();
      syncLastStageProduct();
      if (savePreference) writeMinimalCatalogLayout('mobile', active ? 'grid' : 'single');
    };

    /* The editor is for configuring the cards, so always render every card
       there. The one-product stage stays exclusively on the live storefront,
       where its scrolling and animation can be tested without editor reloads. */
    if (isThemeEditor && window.innerWidth < 750) {
      setMobileGrid(true, false);
    } else if (isThemeEditor) {
      setLayout(false, false);
    } else if (window.innerWidth < 750 && savedLayout.mobile) {
      setMobileGrid(savedLayout.mobile === 'grid', false);
    } else if (window.innerWidth >= 750 && savedLayout.desktop) {
      setLayout(savedLayout.desktop !== 'grid', false);
    }

    /* Bind the action to the freshly rendered carousel itself. Shopify replaces
       this section's DOM after every editor setting change; dispatching to the
       current DOM node avoids keeping a stale closure from the prior render. */
    const toggleCatalogLayout = () => {
      if (window.innerWidth < 750) {
        setMobileGrid(!mobileGridActive);
        return;
      }

      if (canUseDesktopGrid && window.innerWidth >= 750) {
        setLayout(!isSingleLayout);
      }
    };

    /* The header can survive a Shopify section replacement while this carousel
       is recreated. Expose one tiny current-DOM controller, so the visible
       grid button never keeps a listener bound to an obsolete section node. */
    carousel.minimalToggleCatalogLayout = toggleCatalogLayout;
    window.minimalCatalogToggleLayout = () => {
      document.querySelector('[data-product-carousel]')?.minimalToggleCatalogLayout?.();
    };
    carousel.addEventListener('minimal-layout-toggle', toggleCatalogLayout);

    notifyLayoutState();
    window.requestAnimationFrame(notifyLayoutState);
    syncStageMediaArrows();
    syncProductCounter();
    syncLastStageProduct();
    warmProductImage(activeIndex + 1);
    stageMediaPrevious?.addEventListener('click', () => {
      productSlides[activeIndex]?.querySelector('[data-product-media-carousel]')?.dispatchEvent(new Event('minimal:previous-image'));
    });

    stageMediaNext?.addEventListener('click', () => {
      productSlides[activeIndex]?.querySelector('[data-product-media-carousel]')?.dispatchEvent(new Event('minimal:next-image'));
    });

    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { root: viewport, rootMargin: '0px 0px -12% 0px', threshold: .16 });

      productSlides.forEach((slide) => revealObserver.observe(slide));
    } else {
      productSlides.forEach((slide) => slide.classList.add('is-revealed'));
    }

    if (previewThemeId) {
      carousel.querySelectorAll('[data-product-page-link]').forEach((link) => {
        const productUrl = new URL(link.href, window.location.origin);
        productUrl.searchParams.set('preview_theme_id', previewThemeId);
        link.href = productUrl.toString();
      });
    }

    const handleCarouselWheel = (event) => {
      if (window.innerWidth < 750) return;
      if (!usesStageCarousel()) return;

      /* In the desktop vertical stage, keep the browser's own smooth scroll
         and snap. Only the extra wheel movement after the final card hands
         control to the page footer. */
      if (usesNativeStage()) {
        const atNativeStageEnd = activeIndex === productSlides.length - 1
          && viewport.scrollTop >= viewport.scrollHeight - viewport.clientHeight - 2;
        if (atNativeStageEnd && event.deltaY > 8) {
          event.preventDefault();
          setFooterOpen(true);
        }
        return;
      }

      const isHorizontal = usesHorizontalCarousel();
      const primaryDelta = isHorizontal ? event.deltaX : event.deltaY;
      const secondaryDelta = isHorizontal ? event.deltaY : event.deltaX;
      if (Math.abs(primaryDelta) <= Math.abs(secondaryDelta) || Math.abs(primaryDelta) < 8) return;

      const direction = primaryDelta > 0 ? 1 : -1;

      /* A trackpad keeps emitting momentum after the gesture that selects the
         last product. Hold only that tail so the last stage can settle before
         the following, separate gesture continues into the newsletter. */
      if (isLastStageProduct() && !desktopLastStageReady) {
        event.preventDefault();
        armDesktopLastStageHandoff();
        return;
      }

      if (isLastStageProduct()) {
        if (direction > 0) return;
        if (pageScroller && pageScroller.scrollTop > 0) return;
      }

      /* Once the footer is open, it belongs to the normal page scroll. Do not
         intercept its wheel events with the product carousel. */
      if (footerOpen) {
        if (pageScroller && pageScroller.scrollTop > 0) return;
        if (direction < 0) {
          event.preventDefault();
          setFooterOpen(false);
        }
        return;
      }

      if (Date.now() < stageResumeLockedUntil) {
        event.preventDefault();
        return;
      }

      /* The catalog is a fixed slide stage. Never hand trackpad momentum to
         the surrounding scroller: that is what intermittently left the last
         product halfway off-screen with the footer underneath it. */
      event.preventDefault();

      /* A single trackpad gesture can emit many wheel events. Keep it to one
         product, but accept a genuine opposite-direction swipe immediately. */
      window.clearTimeout(wheelGestureReleaseTimer);
      wheelGestureReleaseTimer = window.setTimeout(() => {
        wheelGestureActive = false;
        wheelGestureDirection = 0;
      }, 75);

      if (wheelGestureActive && wheelGestureDirection === direction) return;
      wheelGestureActive = true;
      wheelGestureDirection = direction;

      if (pageScroller && pageScroller.scrollTop !== 0) {
        resetCatalogScroll();
        return;
      }

      const indexBeforeNavigation = activeIndex;
      const footerWasOpen = footerOpen;
      navigateStage(direction);

      if (activeIndex === indexBeforeNavigation && footerOpen === footerWasOpen) return;
    };

    (pageScroller || viewport).addEventListener('wheel', handleCarouselWheel, { passive: false });

    viewport.addEventListener('scroll', () => {
      if (!usesNativeStage() || nativeStageScrollFrame) return;
      nativeStageScrollFrame = window.requestAnimationFrame(syncNativeStage);
    }, { passive: true });

    /* Covers scrollbar dragging, keyboard scrolling and any momentum event
       that reaches the container after a slide transition. */
    if (pageScroller) {
      pageScroller.addEventListener('scroll', () => {
        if (!footerOpen && usesStageCarousel() && pageScroller.scrollTop !== 0 && !isLastStageProduct()) {
          resetCatalogScroll();
        }
      }, { passive: true });
    }

    viewport.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      startY = event.clientY;
      swipeOffset = 0;
      if (event.target.closest('[data-product-media-carousel]')) return;
      if (usesNativeStage()) return;
      if (!usesStageCarousel() || (usesVerticalCarousel() && event.pointerType === 'mouse')) return;
      if (isMobileLastProduct()) return;
      carousel.classList.add('is-dragging');
      viewport.setPointerCapture?.(event.pointerId);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!usesStageCarousel() || !carousel.classList.contains('is-dragging')) return;

      const distance = usesHorizontalCarousel() ? event.clientX - startX : event.clientY - startY;
      const atStart = activeIndex === 0 && distance > 0;
      const atEnd = activeIndex === productSlides.length - 1 && distance < 0;
      swipeOffset = Math.max(-150, Math.min(150, distance * (atStart || atEnd ? .18 : .62)));
      if (window.innerWidth >= 750) {
        updateTrackPosition(swipeOffset);
        return;
      }

      if (!mobileDragFrame) mobileDragFrame = window.requestAnimationFrame(updateMobileDragPosition);
    });

    viewport.addEventListener('pointerup', (event) => {
      if (!usesStageCarousel() || !carousel.classList.contains('is-dragging')) return;

      const distance = usesHorizontalCarousel() ? event.clientX - startX : event.clientY - startY;
      carousel.classList.remove('is-dragging');
      swipeOffset = 0;
      if (mobileDragFrame) {
        window.cancelAnimationFrame(mobileDragFrame);
        mobileDragFrame = 0;
      }

      /* Touch navigation is handled solely by touchend below. Handling the
         pointer event too made a genuine second upward swipe look like a
         duplicate of the first one. */
      if (event.pointerType === 'touch') {
        updateTrackPosition();
        return;
      }

      if (Math.abs(distance) <= 45) {
        updateTrackPosition();
        return;
      }
      if (isMobileLastProduct() && distance < 0) return;
      navigateStage(distance < 0 ? 1 : -1);
    });

    viewport.addEventListener('pointercancel', () => {
      carousel.classList.remove('is-dragging');
      swipeOffset = 0;
      if (mobileDragFrame) {
        window.cancelAnimationFrame(mobileDragFrame);
        mobileDragFrame = 0;
      }
      updateTrackPosition();
    });

    /* Photo galleries own horizontal gestures. When a finger moves vertically
       over a garment, pass that gesture back to the one-product stage instead
       of leaving the user on a dead area of the slide. */
    carousel.addEventListener('minimal:stage-swipe', (event) => {
      if (usesNativeStage()) return;
      if (window.innerWidth >= 750 || !usesVerticalCarousel()) return;
      if (isMobileLastProduct() && event.detail.direction > 0) return;
      navigateStage(event.detail.direction);
    });

    /* Some mobile browsers deliver touch events more reliably than pointer
       events inside a fixed-height, internally scrolling storefront. Keep a
       small fallback so swipe-up/down always advances the product carousel. */
    viewport.addEventListener('touchstart', (event) => {
      /* On the final product, keep a downward swipe available everywhere to
         return to the previous card. An upward swipe still belongs to normal
         page scrolling below the stage. */
      stageTouchEnabled = !event.target.closest('[data-product-media-carousel]');
      startX = event.touches[0]?.clientX || 0;
      startY = event.touches[0]?.clientY || 0;
      if (usesNativeStage()) return;
    }, { passive: true });

    viewport.addEventListener('touchend', (event) => {
      if (usesNativeStage()) {
        /* On phones the one-product catalogue is a closed stage. Letting the
           final card hand off to the footer mixes two scroll containers and
           makes the gallery motion unstable, so the footer stays for grid and
           normal page layouts instead. */
        if (window.innerWidth < 750) return;

        const endY = event.changedTouches[0]?.clientY || startY;
        const atStageEnd = activeIndex === productSlides.length - 1
          && viewport.scrollTop >= viewport.scrollHeight - viewport.clientHeight - 2;

        /* One intentional extra upward swipe after the last product hands
           control back to the normal page. */
        if (atStageEnd && endY - startY < -45) setFooterOpen(true);
        return;
      }
      if (!usesStageCarousel() || !stageTouchEnabled) return;

      const endPoint = event.changedTouches[0];
      const distance = usesHorizontalCarousel()
        ? (endPoint?.clientX || startX) - startX
        : (endPoint?.clientY || startY) - startY;

      if (Math.abs(distance) <= 45) return;
      if (isMobileLastProduct() && distance < 0) return;
      navigateStage(distance < 0 ? 1 : -1);
    }, { passive: true });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 750 && mobileGridActive) {
        setMobileGrid(false);
      }

      if (usesStageCarousel()) {
        if (usesNativeStage() && window.innerWidth < 750) {
          /* iOS resizes while its browser controls move. Native scroll snap
             already tracks that geometry; forcing scrollTop here was what
             made the final image jump away from its card. */
          track.style.transform = '';
        } else {
          updateTrackPosition();
        }
      } else {
        track.style.transform = '';
        productSlides.forEach((slide) => slide.setAttribute('aria-hidden', 'false'));
      }

      notifyLayoutState();
      syncStageMediaArrows();
      syncLastStageProduct();
    });

    /* On a phone, the whole open area of a product card should behave as its
       product link. Explicit controls keep their own actions. */
    productSlides.forEach((slide) => {
      slide.addEventListener('click', (event) => {
        if (window.innerWidth >= 750 || !usesVerticalCarousel() || event.defaultPrevented) return;
        if (event.target.closest('a, button, input, select, textarea, label')) return;

        const productLink = slide.querySelector('a[data-product-page-link].is-active');
        if (productLink?.href) openProductPageFromCard(productLink.href);
      });
    });

    carousel.querySelectorAll('[data-product-toggle]').forEach((toggle) => {
      const slide = toggle.closest('[data-carousel-slide]');
      const sizeOptions = Array.from(slide.querySelectorAll('[data-variant-option]'));

      toggle.addEventListener('click', (event) => {
        event.stopPropagation();

        /* Grid cards keep their compact height. Their plus sign opens the
           product page, where options are available, instead of expanding a
           single card and leaving a blank row underneath its neighbours. */
        if (!isSingleLayout && window.innerWidth >= 750) {
          const productLink = slide.querySelector('[data-product-page-link]');
          if (productLink?.href) openProductPageFromCard(productLink.href);
          return;
        }

        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isExpanded));
        slide.classList.toggle('is-expanded', !isExpanded);
      });

      sizeOptions.forEach((option) => {
        option.addEventListener('click', (event) => {
          event.stopPropagation();
          sizeOptions.forEach((sizeOption) => {
            const isSelected = sizeOption === option;
            sizeOption.classList.toggle('is-selected', isSelected);
            sizeOption.setAttribute('aria-pressed', String(isSelected));
          });

          const purchasePrice = slide.querySelector('[data-purchase-price]');
          const currentPrice = purchasePrice?.querySelector('[data-purchase-current-price]');
          const comparePrice = purchasePrice?.querySelector('[data-purchase-compare-price]');
          const isOnSale = option.dataset.variantOnSale === 'true';

          if (currentPrice) currentPrice.textContent = option.dataset.variantPrice;
          if (comparePrice) {
            comparePrice.hidden = !isOnSale;
            comparePrice.textContent = isOnSale ? option.dataset.variantComparePrice : '';
          }
          purchasePrice?.classList.toggle('product-carousel__purchase-price--sale', isOnSale);
        });
      });
    });

    carousel.querySelectorAll('[data-product-close]').forEach((close) => {
      close.addEventListener('click', (event) => {
        event.stopPropagation();
        const slide = close.closest('[data-carousel-slide]');
        const toggle = slide.querySelector('[data-product-toggle]');

        slide.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });

    carousel.querySelectorAll('[data-add-to-cart]').forEach((addToCart) => {
      addToCart.addEventListener('click', async (event) => {
        event.stopPropagation();
        const slide = addToCart.closest('[data-carousel-slide]');
        const selectedVariant = slide.querySelector('[data-variant-option].is-selected:not(:disabled)');

        if (!selectedVariant) return;

        const defaultLabel = addToCart.dataset.addToCartLabel;
        addToCart.disabled = true;

        try {
          const cartRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${cartRoot}cart/add.js`, {
            body: JSON.stringify({ id: Number(selectedVariant.dataset.variantId), quantity: 1 }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });

          if (!response.ok) throw new Error('Unable to add item');

          window.dispatchEvent(new Event('minimal:cart-updated'));
          addToCart.textContent = addToCart.dataset.addedLabel;
          window.setTimeout(() => {
            addToCart.textContent = defaultLabel;
            addToCart.disabled = false;
          }, 600);
        } catch (error) {
          addToCart.disabled = false;
        }
      });
    });

  });

  /* A multi-product catalogue is ordinary page content, not a carousel. On
     phones the header grid icon can still switch it between one and two cards
     per row without attaching any swipe or viewport-locking behaviour. */
  document.querySelectorAll('.product-carousel--static-grid').forEach((carousel) => {
    let mobileColumns = Number(carousel.style.getPropertyValue('--product-carousel-mobile-columns')) || 1;
    const savedLayout = readMinimalCatalogLayout();
    const isThemeEditor = Boolean(window.Shopify?.designMode);
    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');

    const isMobile = () => window.innerWidth < 750;

    const notifyMobileGridState = () => {
      publishMinimalCatalogLayoutState({
        available: isMobile() || isThemeEditor,
        single: isMobile() ? mobileColumns === 1 : carousel.classList.contains('product-carousel--editor-single-preview')
      });
    };

    const setMobileColumns = (columns, savePreference = true) => {
      mobileColumns = columns;
      carousel.style.setProperty('--product-carousel-mobile-columns', String(columns));
      carousel.style.setProperty('--product-carousel-mobile-media-height', columns === 2 ? '42vw' : '76vw');
      notifyMobileGridState();
      if (savePreference) writeMinimalCatalogLayout('mobile', columns === 2 ? 'grid' : 'single');
    };

    if (isMobile() && savedLayout.mobile) {
      setMobileColumns(savedLayout.mobile === 'grid' ? 2 : 1, false);
    }

    /* Static grids do not use the animated carousel initialiser above, so
       preserve the draft theme when a customer opens a product from a grid. */
    if (previewThemeId) {
      carousel.querySelectorAll('[data-product-page-link]').forEach((link) => {
        const productUrl = new URL(link.href, window.location.origin);
        productUrl.searchParams.set('preview_theme_id', previewThemeId);
        link.href = productUrl.toString();
      });
    }

    const toggleStaticGridLayout = () => {
      if (isMobile()) {
        setMobileColumns(mobileColumns === 1 ? 2 : 1);
        return;
      }

      if (isThemeEditor) {
        const showingSinglePreview = carousel.classList.toggle('product-carousel--editor-single-preview');
        publishMinimalCatalogLayoutState({ available: true, single: showingSinglePreview });
      }
    };

    /* In the theme editor Shopify intentionally uses a static carousel copy.
       Give that copy the same direct controller as the live carousel, so the
       header button still works in the editor's mobile preview. */
    carousel.minimalToggleCatalogLayout = toggleStaticGridLayout;
    window.minimalCatalogToggleLayout = () => {
      document.querySelector('.product-carousel')?.minimalToggleCatalogLayout?.();
    };
    carousel.addEventListener('minimal-layout-toggle', toggleStaticGridLayout);

    window.addEventListener('resize', notifyMobileGridState);
    notifyMobileGridState();
    window.requestAnimationFrame(notifyMobileGridState);
  });

  document.querySelectorAll('[data-product-media-carousel]').forEach((mediaCarousel) => {
    const slides = Array.from(mediaCarousel.querySelectorAll('[data-media-slide]'));
    const mediaTrack = mediaCarousel.querySelector('[data-media-track]');
    const previous = mediaCarousel.querySelector('[data-media-previous]');
    const next = mediaCarousel.querySelector('[data-media-next]');
    const parentCarousel = mediaCarousel.closest('.product-carousel');
    const usesStandardMediaTrack = () => false;
    const dots = Array.from(mediaCarousel.querySelectorAll('[data-media-dot]'));
    const imageTransitionDuration = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 480;
    let activeIndex = 0;
    let startX = 0;
    let startY = 0;
    let wheelLocked = false;
    let wheelReleaseTimer;
    let suppressGestureClick = false;
    let activePointerId = null;
    let isAnimating = false;

    const syncDots = () => {
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    };

    const showImage = (index) => {
      const nextIndex = usesStandardMediaTrack()
        ? Math.max(0, Math.min(index, slides.length - 1))
        : (index + slides.length) % slides.length;

      if (nextIndex === activeIndex || isAnimating) return;
      isAnimating = true;

      const revealNextImage = () => {
      if (usesStandardMediaTrack()) {
        slides[activeIndex].classList.remove('is-active', 'is-entering-right', 'is-entering-left', 'is-exiting-left', 'is-exiting-right');
        slides[nextIndex].classList.remove('is-entering-right', 'is-entering-left', 'is-exiting-left', 'is-exiting-right');
        slides[nextIndex].classList.add('is-active');
        mediaTrack?.style.setProperty('transform', `translate3d(-${nextIndex * 100}%, 0, 0)`);
        activeIndex = nextIndex;
        syncDots();

        slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
        });

        window.setTimeout(() => {
          isAnimating = false;
        }, imageTransitionDuration());
        return;
      }

      const direction = index > activeIndex ? 1 : -1;
      const outgoing = slides[activeIndex];
      const incoming = slides[nextIndex];
      const enteringClass = direction === 1 ? 'is-entering-right' : 'is-entering-left';
      const exitingClass = direction === 1 ? 'is-exiting-left' : 'is-exiting-right';

      outgoing.classList.remove('is-active', 'is-entering-right', 'is-entering-left');
      outgoing.classList.add(exitingClass);
      incoming.classList.remove('is-exiting-left', 'is-exiting-right');
      incoming.classList.add(enteringClass);
      incoming.setAttribute('aria-hidden', 'false');

      window.requestAnimationFrame(() => {
        incoming.classList.add('is-active');
        incoming.classList.remove(enteringClass);
      });

      window.setTimeout(() => {
        outgoing.classList.remove('is-exiting-left', 'is-exiting-right');
        isAnimating = false;
      }, imageTransitionDuration());

      activeIndex = nextIndex;
      syncDots();

      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
      });
      };

      const incomingImage = slides[nextIndex].querySelector('img');
      if (
        !usesStandardMediaTrack()
        && incomingImage
        && !incomingImage.complete
        && typeof incomingImage.decode === 'function'
      ) {
        incomingImage.loading = 'eager';
        incomingImage.decode().then(revealNextImage, revealNextImage);
        return;
      }

      revealNextImage();
    };

    previous?.addEventListener('click', () => showImage(activeIndex - 1));
    next?.addEventListener('click', () => showImage(activeIndex + 1));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => showImage(Number(dot.dataset.mediaDot)));
    });
    mediaCarousel.addEventListener('minimal:previous-image', () => showImage(activeIndex - 1));
    mediaCarousel.addEventListener('minimal:next-image', () => showImage(activeIndex + 1));

    const handleMediaGesture = (horizontalDistance, verticalDistance) => {
      const horizontalAmount = Math.abs(horizontalDistance);
      const verticalAmount = Math.abs(verticalDistance);

      /* Real fingers rarely travel on a perfect axis. Keep a small horizontal
         bias, so a natural diagonal left/right swipe still changes the image
         rather than being mistaken for a product-stage scroll. */
      if (verticalAmount > horizontalAmount * 1.3) {
        if (window.innerWidth < 750 && Math.abs(verticalDistance) > 40) {
          parentCarousel?.dispatchEvent(new CustomEvent('minimal:stage-swipe', {
            detail: { direction: verticalDistance < 0 ? 1 : -1 }
          }));
        }
        return;
      }

      if (horizontalAmount > 32) {
        /* Block only the click emitted by this same drag gesture. A separate
           click starts with pointerdown and is allowed through immediately. */
        suppressGestureClick = true;
        showImage(horizontalDistance > 0 ? activeIndex - 1 : activeIndex + 1);
      }
    };

    const openActiveProduct = (target) => {
      if (target.closest?.('button')) return false;
      const productLink = target.closest?.('a[data-product-page-link]')
        || mediaCarousel.querySelector('a[data-product-page-link].is-active');
      if (!productLink?.href) return false;
      return openProductPageFromCard(productLink.href, productLink);
    };

    mediaCarousel.addEventListener('pointerdown', (event) => {
      /* Gallery dragging owns only the image itself. Capturing a pointer that
         began on a control retargets its click to the gallery and prevents
         the button's own image-switch handler from ever running. */
      if (event.target.closest('[data-media-previous], [data-media-next], [data-media-dot]')) return;

      suppressGestureClick = false;
      activePointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      if (event.pointerType === 'mouse') mediaCarousel.setPointerCapture?.(event.pointerId);
    });

    mediaCarousel.addEventListener('pointermove', (event) => {
      if (event.pointerId !== activePointerId) return;

      const horizontalDistance = event.clientX - startX;
      const verticalDistance = event.clientY - startY;
      if (Math.abs(horizontalDistance) > 12 && Math.abs(horizontalDistance) > Math.abs(verticalDistance)) {
        /* Declare this a gallery gesture before the link can treat it as a
           click. The actual image change still waits until pointerup. */
        event.preventDefault();
      }
    });

    mediaCarousel.addEventListener('pointerup', (event) => {
      if (event.pointerId !== activePointerId) return;
      activePointerId = null;
      if (event.pointerType === 'touch') return;

      const horizontalDistance = event.clientX - startX;
      const verticalDistance = event.clientY - startY;

      if (event.pointerType === 'mouse' && mediaCarousel.hasPointerCapture?.(event.pointerId)) {
        mediaCarousel.releasePointerCapture(event.pointerId);
      }

      event.stopPropagation();
      if (Math.abs(horizontalDistance) <= 8 && Math.abs(verticalDistance) <= 8) {
        if (openActiveProduct(event.target)) event.preventDefault();
        return;
      }
      handleMediaGesture(horizontalDistance, verticalDistance);
    });

    mediaCarousel.addEventListener('pointercancel', () => {
      activePointerId = null;
    });

    mediaCarousel.addEventListener('dragstart', (event) => event.preventDefault());

    /* iOS storefront previews can suppress pointerup on a linked image.
       Keep a touch fallback dedicated to the media track so the photo swipe
       still works while the parent carousel continues to own vertical swipes. */
    mediaCarousel.addEventListener('touchstart', (event) => {
      suppressGestureClick = false;
      startX = event.touches[0]?.clientX || 0;
      startY = event.touches[0]?.clientY || 0;
    }, { passive: true });

    mediaCarousel.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) return;

      const horizontalDistance = touch.clientX - startX;
      const verticalDistance = touch.clientY - startY;
      if (Math.abs(horizontalDistance) <= 8 && Math.abs(verticalDistance) <= 8) {
        if (openActiveProduct(event.target)) event.preventDefault();
        return;
      }
      handleMediaGesture(horizontalDistance, verticalDistance);
    }, { passive: true });

    mediaCarousel.addEventListener('click', (event) => {
      const productLink = event.target.closest('a[data-product-page-link]');
      if (!productLink) return;

      if (suppressGestureClick) {
        suppressGestureClick = false;
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      /* The gallery has several pointer handlers around the same link. Route
         a real photo click explicitly so no parent handler can swallow it. */
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openProductPageFromCard(productLink.href, productLink);
    });

    mediaCarousel.addEventListener('wheel', (event) => {
      const carousel = mediaCarousel.closest('.product-carousel');
      const supportsHorizontalMediaSwipe = carousel?.matches('.product-carousel--columns-1, .product-carousel--columns-2, .product-carousel--columns-3, .product-carousel--columns-4, .product-carousel--columns-5, .product-carousel--columns-6');

      const horizontalDistance = Math.abs(event.deltaX);
      const verticalDistance = Math.abs(event.deltaY);

      if (!supportsHorizontalMediaSwipe || slides.length < 2 || horizontalDistance < 12 || horizontalDistance <= verticalDistance * 1.25) return;

      event.preventDefault();
      event.stopPropagation();
      window.clearTimeout(wheelReleaseTimer);
      wheelReleaseTimer = window.setTimeout(() => {
        wheelLocked = false;
      }, 280);
      if (wheelLocked) return;

      showImage(event.deltaX > 0 ? activeIndex + 1 : activeIndex - 1);
      wheelLocked = true;
    }, { passive: false });
  });

  })();

  } catch(e) { console.error(e); }
})();
})();
